import React, { useEffect, useState, useRef } from 'react';

import { Grid, MenuItem, Button, IconButton } from '@material-ui/core';

import { Form, Input, Select as SelectAntd, Spin } from 'antd';
import { ArrowRightAltOutlined, CloseOutlined } from '@material-ui/icons';
import { useSnackbar } from 'notistack';
import { format, addDays, subDays } from 'date-fns';
import { isReal, ClearString } from '@utils/Masks';
import DatePicker from '@src/components/Shared/DatePicker';



import ButtonComponent from '@components/Shared/Buttons/Button';
import ButtonWithIcon from '@components/Shared/Buttons/ButtonWithIcon';

import InvisibleContent from '@components/Shared/InvisibleContent';

import { mdiArrowTopRight } from '@mdi/js';
import Icon from '@mdi/react';

import Service, {
  IPerfil,
  IRequestSolicitacao,
  ITipoSolicitacao,
  ICampanha,
} from './services';

interface IProps {
  perfil_id: number;
}

const DATA_EMAIL = addDays(new Date(), 7).toISOString().split('T')[0];
const DATA_CORREIO = addDays(new Date(), 30).toISOString().split('T')[0];
const DEBITO_NORMAL_DATA = addDays(new Date(), 0);
const DEBITO_NORMAL_DATA_Ok = addDays(new Date(), 0);


const SolicitacaoComponent: React.FC<IProps> = ({
  perfil_id,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [formRef] = Form.useForm();

  const [loadingCreate, setLoadingCreate] = useState(false);

  const [tiposSolicitacao, setTiposSolicitacao] = useState<ITipoSolicitacao[]>(
    [],
  );
  const [campanhas, setCampanhas] = useState<ICampanha[]>([] || null);

  const [tipoSolicitacaoSelecionada, setTipoSolicitacaoSelecionada] =
    useState('');

  const [loading, setLoading] = useState(true);
  const [loadingCreateSolicitacao, setLoadingCreateSolicitacao] =
    useState(false);

    const [valorModifyValor, setValorModifyValor] =
    useState<string>('');

    const [periodo, SetPerido] = useState<any>([
      subDays(new Date(), 14),
      new Date(),
    ]);

    const [rangeData, setRangeData] = useState<Date[]>([
      DEBITO_NORMAL_DATA,
      DEBITO_NORMAL_DATA,
    ]);

  useEffect(() => {
    const init = async () => {
      const service = new Service();

      const tipoSolicitacaoResponse = await service.loadTiposSolicitacao(
        perfil_id,
      );
      if (!tipoSolicitacaoResponse.error) {
        setTiposSolicitacao(tipoSolicitacaoResponse.response);
      }
    };

    init();
    setLoading(false);
    loadCampanhas();
  }, []);

  async function loadCampanhas() {
    const services = new Service();

    const { error, response } = await services.getCampanhas();
    if (!error && response?.length) {
      setCampanhas(response);
    }
  }

  const filterCheckTipoFormContribuicao = (id: any) => {
    const forma = tiposSolicitacao.filter(x => x.id === id);

    if (forma.length > 0) setTipoSolicitacaoSelecionada(forma[0].descricao);
  };

  async function onSubmit(values: any) {
    setLoadingCreate(true);

    console.log(values);

    const createSolicitacao: IRequestSolicitacao = {
      id_perfil: perfil_id,
      id_tipo_solicitacao: values.id_tipo_solicitacao,
      observacoes: values.observacoes,
      valor: ClearString(valorModifyValor) / 100,
      data_vencimento: values.data_vencimento,
      id_campanha: values.id_campanha,
    };

    const service = new Service();
    const { error, response } = await service.CreateSolicitacao(
      createSolicitacao,
    );

    setLoadingCreate(false);

    if (!error) {
      enqueueSnackbar(`Cadastro finalizado com sucesso!`, {
        variant: 'success',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });
      setLoadingCreateSolicitacao(false);

    } else {
      enqueueSnackbar(`Ocorreu um erro`, {
        variant: 'error',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });
      setLoadingCreateSolicitacao(false);
    }
  }

  const handleArquivo = async ( rangeDatas?: Date[],) => {
    const services = new Service();

    const { error, response } = await services.gerarExtrato(
      perfil_id,
      rangeDatas
        ? `${rangeDatas[0].toLocaleDateString('en-US')}`
        : `${rangeData[0].toLocaleDateString('en-US')}`,
      rangeDatas
        ? `${rangeDatas[1].toLocaleDateString('en-US')}`
        : `${rangeData[1].toLocaleDateString('en-US')}`,
    );

    if (!error && response) {
      window.open(response);
    } else {
      console.log(error);
    }

  };

  const onChangeDates = async (dates: any) => {
    setRangeData(dates);
  };

  return (
    <Grid container>
      <Grid container item sm={12}>
        <Spin
          size="large"
          spinning={loadingCreate}
          tip={loadingCreate ? 'Enviando dados...' : ''}
        >
          <Grid
            container
            item
            xs={12}
            md={12}
            justify="center"
            alignItems="center"
          >
            <Form
              form={formRef}
              scrollToFirstError={true}
              //onFinish={onSubmit}
              requiredMark={false}
              style={{ width: '100%' }}
              layout="vertical"
              initialValues={{
                //qtd_cadastros: totalItens,
                //data_vencimento: format(addDays(new Date(), +7), 'yyyy-MM-dd'),
              }}
            >
               <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                style={{ paddingTop: 0, paddingBottom: 10 }}
              >
                <DatePicker
                  cleanable={false}
                  notUseDefaultValue={true}
                  title=" "
                  color={'default'}
                  setValor={onChangeDates}
                  placement={'bottomStart'}
                  rangeInitial={rangeData}
                />
              </Grid>

              <Grid
                container
                justify="center"
                alignItems="center"
                item
                md={12}
                xs={12}
              >

                <Grid item lg={12} md={12} xs={12} style={{ paddingTop: 10 }}>
                  <ButtonWithIcon
                    color="primary"
                    disabled={loadingCreateSolicitacao}
                    loading={loadingCreateSolicitacao}
                    fullWidth
                    onClick={() => {
                      handleArquivo();
                      //setLoadingButtonBuscar(true);
                     }}
                    type="submit"
                    titleButton="Gerar"
                  ></ButtonWithIcon>
                </Grid>
              </Grid>
            </Form>
          </Grid>
        </Spin>
      </Grid>
    </Grid>
  );
};

export default SolicitacaoComponent;
